export { default } from './NewsPage';



// WEBPACK FOOTER //
// ./src/components/templates/NewsPage/index.js